import { useContext, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import TkButton from "../../components/atoms/TkButton";
import TkHelpIcon from "../../components/atoms/TkHelpIcon";
import TkBackButton from "../../components/molecules/TkBackButton";
import { GlobalContext } from "../../context/globalContext";
import { httpAPI_PRE015 } from "./api/request";
import "./_style.scss";
import { Box, Typography } from "@mui/material";
import { BusinessContext } from "../../context/businessContext";
import _ from "lodash";
import { TkRouteContext } from "../../context/tkRouteContext";

/**
 * SCRC080001 掛金納付対象職員届提出について
 * @return SCRC080001
 */
const SCRC080001 = () => {
  const navigate = useNavigate();

  const { state, setState } = useContext(GlobalContext);
  const { state: businessState, setState: setBusinessState } =
    useContext(BusinessContext);
  const location = useLocation();
  const locationState = location.state;

  const [resData, setResData] = useState<boolean>(false);
  const [confirmFourActivityFlg, setConfirmFourActivityFlg] = useState("");
  const applyId = locationState?.applyId ?? businessState.job_11?.applyId;

  const { state: routerState, setState: setRouterState } =
    useContext(TkRouteContext);
  const wantToSetInRouterList = useRef<any>(
    location.state?.wantToSetInRouterList ?? []
  );

  useEffect(() => {
    if (wantToSetInRouterList.current.length === 0) return;
    if (_.isEqual(wantToSetInRouterList.current, routerState.routerList))
      return;
    setRouterState({
      routerList: wantToSetInRouterList.current as any,
    });
  }, [wantToSetInRouterList, routerState.routerList, setRouterState]);

  useEffect(() => {
    handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleInit = async () => {
    // 掛金納付対象職員届提出についての申請状態取得API実行
    try {
      const res = await httpAPI_PRE015({
        contractorNo: state.authInfo?.contractorNo,
      });

      if (res.resultCd === "I0000") {
        if (res.submissionActivityFlg !== "1") {
          setResData(true);
        }
        setConfirmFourActivityFlg(res?.confirmFourActivityFlg || "");
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  // 掛金届提出手続きへ進むボタン押下時
  const onClickProceedButton = () => {
    // 持回り情報を設定
    setBusinessState({
      common: businessState.common,
      job_11: {
        ...businessState.job_11,
        applyId: applyId,
        confirmFourActivityFlg: confirmFourActivityFlg,
      },
    });
    setState({
      ...state,
      errorMsgId: "",
    });
    // 掛金納付対象職員届提出時の事前確認(SCR0079_1)に遷移
    navigate("/SCRC080002");
  };

  return (
    <Box data-testid="SCRC080001PageForTest" className="SCRC080001Layout">
      <Box>
        <Typography>
          〇掛金納付対象職員届
          <TkHelpIcon helpMessage="掛金納付対象職員届は、社会福祉施設職員等退職手当共済法第２１条、同法施行規則第１４条、社会福祉施設職員等退職手当共済約款第１８条に基づき、ご提出いただくものです。" />
          は、毎事業年度、４月１日現在において使用する被共済職員について４月末日までに報告いただくものです。
        </Typography>
        <Box>
          <Typography>
            〇４月１日現在の状況となるよう内容を更新し、提出を完了させてください。
          </Typography>
          <Typography>
            　※４月１日前から入力はできますが、提出が可能となるのは４月１日からとなります。
          </Typography>
        </Box>

        <Box className="tkButtonBox">
          <TkBackButton />
          <TkButton onClick={onClickProceedButton} disabled={resData}>
            掛金届提出手続きへ進む
          </TkButton>
        </Box>
      </Box>
    </Box>
  );
};

export default SCRC080001;
